import fetch from "../fetch";

export default ({ id } = {}) =>
  fetch({ path: `/re/prop-masters/${id}/relationships` });
